import React from 'react';
import {
  FormGroup as ReactFormGroup,
  FormGroupProps as ReactFormGroupProps,
} from 'react-bootstrap';
import styled from 'styled-components';

import formAlertImg from 'assets/images/form-alert.png';

interface FormGroupProps extends ReactFormGroupProps {
  hasError?: boolean;
}

export const FormGroup = ({
  hasError,
  children,
}: React.PropsWithChildren<FormGroupProps>) => (
  <Container hasError={hasError}>{children}</Container>
);

const Container = styled(ReactFormGroup)<{ hasError?: boolean }>`
  input {
    border-bottom-color: ${(props) =>
      props.hasError
        ? props.theme.color.ui.danger
        : props.theme.color.ui.shade2};
    background-image: ${(props) => props.hasError && `url(${formAlertImg})`};
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: calc(100% - 12px);
  }
  select {
    border-bottom-color: ${(props) =>
      props.hasError
        ? props.theme.color.ui.danger
        : props.theme.color.ui.shade2};
    background-image: ${(props) => props.hasError && `url(${formAlertImg})`};
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: calc(100% - 12px);
  }
  span {
    color: ${(props) => props.theme.color.text.danger};
  }
`;
